import { useCallback, useEffect, useState } from "react";
import { useQuery } from "@apollo/react-hooks";
import { GET_SPENDINGS } from "../api/spending";

export default (size, filters = {}) => {
  const [loadMoreDisabled, setLoadMoreDisabled] = useState(false);

  const result = useQuery(GET_SPENDINGS, {
    variables: {
      ...filters,
      offset: 0,
      limit: size,
    },
    // 月檢視與最新檢視各是一份 cache entry，跨視圖 mutation 只更新當下那份；
    // 切換視圖時靠 cache-and-network 回網路刷新來修正另一份的過時資料，勿改成 cache-first。
    fetchPolicy: "cache-and-network",
    notifyOnNetworkStatusChange: true,
    // 401 由 apolloClient 全域統一處理（提示 + 導向登入）；此處僅停止「載入更多」。
    onError() {
      setLoadMoreDisabled(true);
    },
    onCompleted(data) {
      if (data.spendings.length === 0) {
        setLoadMoreDisabled(true);
      }
    },
  });

  // filters 變動（例如快轉切換月份）代表換了一份全新的結果集，
  // 重置「已到底」狀態，避免沿用上一個視窗載入完畢的旗標。
  const filtersKey = JSON.stringify(filters);
  useEffect(() => {
    setLoadMoreDisabled(false);
  }, [filtersKey]);

  const { data, fetchMore, variables } = result;

  const loadMore = useCallback(() => {
    if (loadMoreDisabled) {
      return;
    }

    fetchMore({
      variables: {
        offset: data.spendings.length,
      },
      updateQuery: (prev, { fetchMoreResult }) => {
        if (!fetchMoreResult) return prev;

        if (fetchMoreResult.spendings.length === 0) {
          setLoadMoreDisabled(true);
        }

        return {
          ...prev,
          spendings: [...prev.spendings, ...fetchMoreResult.spendings],
        };
      },
    });
  }, [fetchMore, loadMoreDisabled, data]);

  return {
    ...result,
    loadMore,
    loadMoreDisabled,
    queryOption: {
      query: GET_SPENDINGS,
      variables,
    },
  };
};
